import { render, staticRenderFns } from "./RiskIdentifyPlan.vue?vue&type=template&id=119a2cf1&scoped=true"
import script from "./RiskIdentifyPlan.vue?vue&type=script&lang=js"
export * from "./RiskIdentifyPlan.vue?vue&type=script&lang=js"
import style0 from "./RiskIdentifyPlan.vue?vue&type=style&index=0&id=119a2cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a2cf1",
  null
  
)

export default component.exports